export default __webpack_public_path__ + "static/popup-editor-1-98921913e805f3ebcaf8ea9c502ad9a6.png";